import { cancellationThunksFactory } from 'state/secondaryMarket/shared/cancellation/cancellation.thunks';

export const liveCancellationThunks = cancellationThunksFactory('LIVE');
